import { Pipe, PipeTransform } from '@angular/core';

import { NotificationEntity } from '../../entities/notifications/notification.entity';

@Pipe({
    standalone: false,
    name: 'isDeleteNotification',
    pure: true
})
export class IsDeleteNotificationPipe implements PipeTransform {
    transform(notification: NotificationEntity): boolean {
        return notification.Tag.indexOf('deleted') >= 0;
    }
}
